export const settings = {
  apiKey: 'f337901f-06e6-4656-805a-3bec4d0e0751',
  lang: 'ru_RU',
  coordorder: 'latlong',
  version: '2.1',
  debug: true,
};
